import React, {Component} from 'react';
import {translate} from 'react-i18next';
import fusionIcon from '../../gfx/icon-fusion.png';
import {
    HashRouter as Router
} from 'react-router-dom';
import NavLink from './NavLink';
import {connect} from "react-redux";

class NavbarLeft extends Component {
    render() {
        const {t, roles, scope} = this.props;
        return (
            <nav className="NavbarLeft navbar-default navbar-static-side" id="navbarLeft">
                <div className="sidebar-collapse">
                    <Router>
                        <ul className="nav metismenu" id="side-menu">
                            <li className="nav-header">
                                <img src={fusionIcon} alt="Fusion"/>
                            </li>
                            <NavLink exact to="/" activeClassName="active">
                                {t('menu.overview')}
                            </NavLink>
                            {/*<NavLink to="/tablet" activeClassName="active">
                                Runner
                            </NavLink>*/}
                            {scope.full && scope.full.backendModules ? scope.full.backendModules.map((module, mI) => {
                                switch (module) {
                                    case "LOGBOOK": {
                                        return (
                                            <NavLink to="/logbook" activeClassName="active" key={mI}>
                                                {t('menu.logbook')}
                                            </NavLink>
                                        )
                                    }
                                    case "PERSONS": {
                                        return (
                                            <NavLink to="/supporter" activeClassName="active" key={mI}>
                                                {t('menu.supporter')}
                                            </NavLink>
                                        )
                                    }
                                    case "APPLICATION": {
                                        return (
                                            <NavLink to="/application" activeClassName="active" key={mI}>
                                                {t('menu.application')}
                                            </NavLink>
                                        )
                                    }
                                    case "SCHEDULE": {
                                        return (
                                            <NavLink to="/schedule" activeClassName="active" key={mI}>
                                                {t('menu.schedule')}
                                            </NavLink>
                                        )
                                    }
                                    case "SHIFT_LISTS": {
                                        return (
                                            <NavLink to="/shiftLists" activeClassName="active" key={mI}>
                                                {t('menu.shiftLists')}
                                            </NavLink>
                                        )
                                    }
                                    case "LOCATIONS": {
                                        return (
                                            <NavLink to="/locations" activeClassName="active" key={mI}>
                                                {t('menu.locations')}
                                            </NavLink>
                                        )
                                    }
                                    case "ROUTES": {
                                        return (
                                            <NavLink to="/routes" activeClassName="active" key={mI}>
                                                {t('menu.routes')}
                                            </NavLink>
                                        )
                                    }
                                    case "QUEUE_LIST": {
                                        return (
                                            <NavLink to="/queue" activeClassName="active" key={mI}>
                                                {t('menu.queueList')}
                                            </NavLink>
                                        )
                                    }
                                    case "TRANSLATION": {
                                        return roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                            <NavLink to="/translation" activeClassName="active" key={mI}>
                                                {t('menu.translation')}
                                            </NavLink>
                                        ) : null
                                    }
                                    case "BATCH_ACTIONS": {
                                        return roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                            <NavLink to="/batch" activeClassName="active" key={mI}>
                                                {t('menu.batchActions')}
                                            </NavLink>
                                        ) : null
                                    }
                                    case "USER_MANAGEMENT": {
                                        return this.props.roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                            <NavLink to="/userManagement" activeClassName="active" key={mI}>
                                                {t('menu.userManagement')}
                                            </NavLink>
                                        ) : null
                                    }
                                    case "CASH_REGISTER": {
                                        return (
                                            <NavLink to="/cashRegister" activeClassName="active" key={mI}>
                                                {t('menu.cashRegister')}
                                            </NavLink>
                                        )
                                    }
                                    case "PROJECT_MANAGEMENT": {
                                        return roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                            <NavLink to="/projectManagement" activeClassName="active" key={mI}>
                                                {t('menu.projectManagement')}
                                            </NavLink>
                                        ) : null
                                    }
                                    case "PROJECT_STATS": {
                                        return roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                            <NavLink to="/projectStats" activeClassName="active" key={mI}>
                                                {t('menu.projectStats')}
                                            </NavLink>
                                        ) : null
                                    }
                                    case "COMPANIES": {
                                        return roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                            <NavLink to="/companies" activeClassName="active" key={mI} isActive={(match, path) => path.pathname.indexOf('/compan') === 0}>
                                                {t('menu.companies')}
                                            </NavLink>
                                        ) : null
                                    }
                                    default:
                                        return null;
                                }
                            }) : null}
                        </ul>
                    </Router>
                </div>
            </nav>
        )
    }
}

const mapStateToProps = state => {
    return {
        roles: state.authorization.roles,
        scope: state.scope
    }
};

export default connect(mapStateToProps, {

})(translate()(NavbarLeft));
